import script from "./adjustments-account-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./adjustments-account-item.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__